import { languages, findSupportedLanguageTag } from '@logto/language-kit';
import { z } from 'zod';
import en from './locales/en/index.js';
import ja from './locales/ja/index.js';
import viVN from './locales/vi-vn/index.js';
// TDA: trimmed from 20 locales to the three TDA actually ships — EN for
// engineering, JA for 自治体 customers, VI for the team in Vietnam.
// Every removed locale was dead weight in the bundle and in translation review.
// `vi-VN` is new; Logto never shipped Vietnamese.
export const builtInLanguages = ['en', 'ja', 'vi-VN'];
export const builtInLanguageOptions = builtInLanguages.map((languageTag) => ({
    value: languageTag,
    title: languages[languageTag],
}));
export const builtInLanguageTagGuard = z.enum(builtInLanguages);
const resource = {
    en,
    ja,
    'vi-VN': viVN,
};
export const getDefaultLanguageTag = (language) => builtInLanguageTagGuard.parse(findSupportedLanguageTag(language ? [language] : [], builtInLanguages, 'en'));
export const isBuiltInLanguageTag = (language) => builtInLanguageTagGuard.safeParse(language).success;
export default resource;
